export const API_BASE = process.env.TIMESHEETS_API;
export const API_PATH = 'v1/timesheets';
